import { render, staticRenderFns } from "./AddCommentWidget.vue?vue&type=template&id=7cd5107c&scoped=true&"
import script from "./AddCommentWidget.vue?vue&type=script&lang=js&"
export * from "./AddCommentWidget.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentWidget.vue?vue&type=style&index=0&id=7cd5107c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5107c",
  null
  
)

export default component.exports